<template>
  <div class="faq-lists">
    <div class="faq-list" v-for="(list, listId) in listDesc" :key="listId">
      <p class="title" v-html="list.title"></p>
      <ol class="list" v-bind:type="list.type">
        <li v-for="(en, enId) in list.enum" :key="enId" v-html="en"></li>
      </ol>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ListDescription',
  props: {
    listDesc: Array,
  },
};
</script>
